import jump from 'jump.js'

document.addEventListener("turbolinks:load", function(event) {

  const target = document.querySelector('.target')

  document.querySelectorAll('.jump-to-target').forEach(function(element){
    element.addEventListener('click', function(e){
      e.preventDefault()
      jump(target)
    })
  })

})
